import React, { useEffect, useState } from "react";
import "./footer.css";
import Sikh from "../../../src/assets/images/img/SikhLogo.png";
import { Link, useNavigate } from "react-router-dom";
import { BsYoutube, BsFacebook, BsInstagram } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import Magisticlogo from "../../../src/assets/images/img/megisticLogo2.png";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { needCall } from "../Header/Data";
import { FaPhoneAlt } from "react-icons/fa";
import { listGurudwaras } from "../Header/Data";
import { Button, Modal, ModalBody, FormGroup, Label, Input } from "reactstrap";
import { GrFormClose } from "react-icons/gr";
import "bootstrap/dist/css/bootstrap.min.css";

import DonateModal from "../Header/modals/DonateModal";
import {
  setDonationClientId,
  setDonationFrom,
  setDonationSecretKey,
  setDonationStatus,
  setMonthlyDonation,
  setOpenPaypal,
  setSelectedAmount,
  setSelectedGurdwara,
} from "../../redux/slices/DonationSlice";
import ThankYouModal from "../../pages/DashboardPages/Orders/ThankYouPage";
import {
  setSelectedSubCategory,
  setViewCustType,
} from "../../redux/slices/LcaSlice";
import Swal from "sweetalert2";
import {
  fetchMyGurdwaraBookings,
  resetGurdwara,
} from "../../redux/slices/GurdwaraSlice";
import SelectGurdwaraModal from "../Header/SelectGurdwaraModal";

const Footer = ({ isOpen }) => {
  const [privacy, setPrivacy] = useState("");
  const [shipping, setShipping] = useState("");
  // const [isOpen, setIsOpen] = useState("");
  const [gurdwaras, setGurdwaras] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [gurdwaraId, setGurdwaraId] = useState(null);
  const [gurdwaraName, setGurdwaraName] = useState("");
  const { myGuruLoading, myGuruBookingList, myGuruError } = useSelector(
    (state) => state.gurdwara
  );
  let myLatestGuruBooking =
    myGuruBookingList &&
    myGuruBookingList.filter(
      (item) =>
        (item.paymentStatus == "PENDING" || item.paymentStatus == null) &&
        item.gurudwaraId == gurdwaraId
    )[0];
  const isHomePage =
    location.pathname === "/" ||
    location.pathname === "/home" ||
    location.pathname === "/Localcommunityads";
  const isBrowsePage =
    location.pathname === "/weddingvendors?selected=vendors-grid";
  const isMajesticHomePage = location.pathname === "/majesticHomePage";
  const isVendorDetailsPage = location.pathname.includes("/vendordetails");
  const isInvoicePaymentPage = location.pathname.includes("/invoicePayment");
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalClosed, setModalClosed] = useState(false);
  const [thankYou, setThankYou] = useState(false);
  const donationType = "Footer";
  const { donationStatus, donationFrom } = useSelector(
    (state) => state.gurdwaraDonation
  );
  const isProfileComplete = !!(
    user &&
    user.FirstName &&
    user.LastName &&
    user.Email &&
    user.Phone &&
    user.UserName &&
    user.Radius &&
    user.Location &&
    user.ZipCode
  );

  const toggleModal = () => {
    // Check for iPad (including iPad Pro) using user agent and screen size
    const isIpad =
      /iPad|Macintosh/i.test(navigator.userAgent) && "ontouchstart" in window;
    const isIpadPro =
      (isIpad && window.innerWidth === 1024 && window.innerHeight === 1366) ||
      (window.innerWidth === 1366 && window.innerHeight === 1024) ||
      (window.innerWidth === 834 && window.innerHeight === 1194) ||
      (window.innerWidth === 1194 && window.innerHeight === 834);

    // if (!islogin && !isIpad && !isIpadPro) {
    //   toast.info("Please login to book a Gurdwara.");
    //   return;
    // }

    if (!isOpen && !isProfileComplete && islogin) {
      toast.info("Please complete your profile.");
      return;
    }
    setGurdwaraId(null);
    setGurdwaraName("");
    setModal(!modal);
  };
  const handleClick = (e) => {
    const selectedValue = e.target.value;
    const selectedGurdwaraData = gurdwaras.find(
      (gurudwara) => gurudwara.Id === parseInt(selectedValue)
    );
    setGurdwaraId(selectedValue);
    setGurdwaraName(selectedGurdwaraData ? selectedGurdwaraData.Title : "");
    if (!islogin) {
      return;
    }
    dispatch(fetchMyGurdwaraBookings(user.UserID));
  };

  const handleSubmit = () => {
    const cleanedGurdwaraName = gurdwaraName.replace(/\s+/g, "");
    if (cleanedGurdwaraName === "") {
      toast.error("Please select Gurdwara");
      return;
    }
    if (myLatestGuruBooking) {
      Swal.fire({
        title: `Do you want to finish the booking inquiry you started with ${gurdwaraName}?`,
        // showCancelButton: true,
        confirmButtonText: "Yes",
        // cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          // navigate(
          //   `/bookGurdwara/${cleanedGurdwaraName}/Fill-your-Info?id=${gurdwaraId}`,
          //   {
          //     state: {
          //       myLatestGuruBooking: myLatestGuruBooking,
          //       editType: "BOOKING_USER",
          //     },
          //   }
          // );
          // Store the state in sessionStorage
          localStorage.setItem(
            "myLatestGuruBooking",
            JSON.stringify(myLatestGuruBooking)
          );
          localStorage.setItem("editType", "GURDWARA_ADMIN");

          // Open the new tab
          window.open(
            `/#/bookGurdwara/${cleanedGurdwaraName}/Fill-your-Info?id=${gurdwaraId}`,
            "_blank",
            "noopener,noreferrer"
          );
          navigate({
            state: {
              myLatestGuruBooking: myLatestGuruBooking,
              editType: "BOOKING_USER",
            },
          });
        }
        // else {
        //   localStorage.removeItem("myLatestGuruBooking");
        //   localStorage.removeItem("editType");
        //   window.open(
        //     `/#/bookGurdwara/${cleanedGurdwaraName}/Fill-your-Info?id=${gurdwaraId}`,
        //     "_blank",
        //     "noopener,noreferrer"
        //   );
        //   dispatch(resetGurdwara());
        // }
      });
    } else {
      localStorage.removeItem("myLatestGuruBooking");
      localStorage.removeItem("editType");
      window.open(
        `/#/bookGurdwara/${cleanedGurdwaraName}/Fill-your-Info?id=${gurdwaraId}`,
        "_blank",
        "noopener,noreferrer"
      );
      dispatch(resetGurdwara());
    }

    toggleModal();
  };

  const handleZoomWelcomePageClick = () => {
    window.scrollTo(0, 0);
  };

  const fetchData = async () => {
    const gurudwaras = await listGurudwaras();
    setGurdwaras(gurudwaras);
  };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  useEffect(() => {
    if (donationFrom === "FOOTER" && donationStatus === "COMPLETED") {
      setModalIsOpen(false);
      setModalClosed(true);
      dispatch(setDonationStatus(""));
      dispatch(setDonationFrom(""));
      setThankYou(true);
    }
  }, [donationStatus]);

  // Helper function to handle navigation with profile check
  const handleNavigation = (path, open) => {
    if (!islogin && !open) {
      toast.info("Please login to book a Gurdwara.");
      return;
    }
    if (!open && !isProfileComplete) {
      toast.info("Please complete your profile.");
      return;
    }
    navigate(path);
  };

  return (
    <>
      <footer className="py-4 bg-white">
        <div className="px-5 mx-2">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="office__info pe-5">
                {isBrowsePage ||
                isMajesticHomePage ||
                isVendorDetailsPage ||
                isInvoicePaymentPage ? (
                  <img
                    className="d-lg-block wc-logo2"
                    src={Magisticlogo}
                    alt="logo"
                  />
                ) : (
                  <img className="d-lg-block wc-logo" src={Sikh} alt="logo" />
                )}
                <div className="social_icons d-flex align-items-center gap-15 mt-4">
                  <a
                    href="https://www.youtube.com/channel/UCDktIvmaFNB5rcAOevDXUrw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsYoutube className="fs-5" />
                  </a>
                  <a
                    href="https://www.facebook.com/people/Indian-Wedding-Vendors-LLC/100088337712267/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsFacebook className="fs-5" />
                  </a>
                  <a
                    href="https://www.instagram.com/myindiancommunity/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsInstagram className="fs-5" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6">
              <div className="footer-links d-flex flex-column">
                <Link
                  className="text-dark py-2 mb-1"
                  to=""
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/create-service");
                  }}
                >
                  Sell
                </Link>
                <Link
                  className="text-dark py-2 mb-1"
                  to="/weddingvendors?selected=vendors-grid"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/weddingvendors?selected=vendors-grid");
                  }}
                >
                  Browse Listing
                </Link>
                <Link
                  className="text-dark py-2 mb-1"
                  to={`about/shipping/${shipping}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation(`about/shipping/${shipping}`);
                  }}
                >
                  Browse Action
                </Link>
              </div>
            </div>
            <div className="col-lg-2 col-md-6">
              <div className="footer-links d-flex flex-column">
                <Link className="text-dark py-2 mb-1" to="/privacypolicies">
                  Privacy Policies
                </Link>
                <Link className="text-dark py-2 mb-1" to="/aboutus">
                  About Us
                </Link>
                <Link className="text-dark py-2 mb-1" to="/contact/us/ll">
                  Contact Us
                </Link>
                <Link
                  className="text-dark py-2 mb-1"
                  to="/pricing"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/pricing");
                  }}
                >
                  Pricing
                </Link>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 footer-actions">
              <div className="action-links">
                <Link
                  to="/create-need/request"
                  className="mt-2 text-decoration-underline"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/create-need/request", true);
                  }}
                >
                  Post Your Ad
                </Link>
                {isHomePage && (
                  <p
                    className="mt-2 text-primary text-decoration-underline"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (!isProfileComplete) {
                        toast.info("Please complete your profile.");
                        return;
                      }
                      dispatch(setViewCustType(true));
                      navigate("/Localcommunityads?subcategory=Event+Businesses+%26+Customers&tab=Customers");
                    }}
                  >
                    View Customers
                  </p>
                )}
              </div>

              <button
                type="button"
                className="btn btn-sm btn-primary mt-3"
                onClick={toggleModal}
              >
                <span className="mx-1">Book a Gurdwara</span>
              </button>

              <div>
                <button
                  className="btn btn-sm btn-primary mt-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (!isProfileComplete) {
                      toast.info("Please complete your profile.");
                      return;
                    }
                    setModalIsOpen(true);
                    dispatch(setDonationFrom("FOOTER"));
                  }}
                >
                  Donate to Gurdwara
                </button>
              </div>

              <DonateModal
                modalIsOpen={modalIsOpen}
                setModalIsOpen={setModalIsOpen}
                Type={donationType}
                onClose={() => {
                  setModalClosed(true);
                  setModalIsOpen(false);
                }}
                handleFormSubmit={true}
              />
            </div>

            {isBrowsePage ||
            isMajesticHomePage ||
            isVendorDetailsPage ||
            isInvoicePaymentPage ? (
              <p className="footer__copyright mt-2 text-dark align-items-center">
                © Majestic Events All rights reserved
              </p>
            ) : (
              <p className="footer__copyright mt-2 text-dark align-items-center">
                © My Sikh Community.COM All rights reserved
              </p>
            )}
          </div>
        </div>
      </footer>
      <ThankYouModal
        show={thankYou}
        onHide={() => setThankYou(false)}
        state={{ donation: true }}
      />
      {modal && (
        <SelectGurdwaraModal
          isOpen={modal}
          toggleModal={toggleModal}
          gurdwaraId={gurdwaraId}
          setGurdwaraId={setGurdwaraId}
          gurdwaraName={gurdwaraName}
          setGurdwaraName={setGurdwaraName}
        />
      )}
    </>
  );
};

export default Footer;
